export const ARTIST = 'artist';
export const TITLE = 'title';

export const SORT_LIST = [TITLE, ARTIST];
